import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Layout, Avatar } from 'antd';
import { Link } from 'react-router-dom';
import { SFButton } from '../../../components/SF-UI';
import logo from './components/Circle-icons-motorcycle.svg.png';
import { checkPermissionsHOC } from '../../App/CheckPermissions';
import { NotFound } from '../../App/components/NotFound';
import BikeSearch from './components/BikeSearch';


class Index extends Component {
    componentWillUnmount() {
        this.props.dispatch({ type: 'RESET_PERMISSIONS' });
    }

    layout_position = { padding: '0 5%' };

    render() {
        const { views_permissions, isShow, amount } = this.props;
        const view_parent_access = views_permissions['view://PlatformManagement/BikeManagement'];
        const model_create_access = views_permissions['view://PlatformManagement/Bike_model_create'];
        if (!view_parent_access) {
            return <NotFound />;
        }
        return (
            <Layout style={this.layout_position}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px' }}>
                    <div style={{ display: 'inherit', paddingTop: '10px' }}>
                        <div style={{ marginRight: '15px' }}>
                            <Avatar size={60} src={logo} />
                        </div>
                        <div>
                            <h3 className="page-title" style={{ marginBottom: 0 }}>{isShow ? 'Search Results' : 'Bike Management'}</h3>
                            <h3 className="page-subhead subhead">
                                {isShow
                                    ? `Our results found ${amount} bikes matching your criteria`
                                    : 'Manage_retail the central database of bikes within the platform.'}
                            </h3>
                        </div>
                    </div>
                    <div style={{ fontSize: 20, marginTop: '2%' }}>
                        {!model_create_access ? (
                            <span style={{
                                margin: '0 5px 0 20px', fontStyle: 'italic', fontSize: 12, color: 'red',
                            }}
                            >
                                No Access Rights
                            </span>
                        ) : null}
                        <SFButton type="primary" style={{ marginLeft: 20 }} disabled={!model_create_access}>
                            <Link to="/PlatformManagement/Bike_model_create">Add New Model</Link>
                        </SFButton>
                    </div>
                </div>
                <BikeSearch />
            </Layout>
        );
    }
}

const mapStateToProps = state => ({
    views_permissions: state.App.Permissions.views_permissions,
    isShow: state.PlatformManagement.Bike_management.isShow,
    amount: state.PlatformManagement.Bike_management.amount,
});

export default connect(mapStateToProps)(checkPermissionsHOC(Index, ['view://PlatformManagement/BikeManagement', 'view://PlatformManagement/Bike_model_create', 'view://PlatformManagement/Bike_model_update']));



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/BikeManagement/index.js